/** Barra 0-100 con etiqueta. La usan los componentes del IPC y los ejes. */
export function Meter({
  label,
  value,
  color,
  hint,
  max = 100,
}: {
  label: string;
  value: number;
  color: string;
  hint?: string;
  max?: number;
}) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div>
      <div className="flex items-baseline justify-between gap-4">
        <span className="text-caption text-ink/70">{label}</span>
        <span className="text-caption font-medium tabular-nums">{Math.round(value)}</span>
      </div>
      <div
        className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-ink-mid/25"
        role="meter"
        aria-valuenow={Math.round(value)}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-label={label}
      >
        <div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
      {hint && <p className="mt-1 text-caption text-ink/50">{hint}</p>}
    </div>
  );
}

/** Etiqueta de banda: el color comunica el estado sin depender del texto. */
export function Badge({ text, color }: { text: string; color: string }) {
  return (
    <span
      className="inline-flex items-center rounded-full px-3 py-1 text-caption font-medium"
      style={{ backgroundColor: `${color}1A`, color }}
    >
      {text}
    </span>
  );
}
